import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'censureCellPipe'
})
export class CensureCellPipe implements PipeTransform {
  transform(value: string): string | null | undefined {
    if (!value) { return value };
    const numberFirstPart = 4;
    const numberSecondPart = -2;

    const cell1 = value.toString().slice(0, numberFirstPart);
    const cell2 = value.toString().slice(numberSecondPart);
    return cell1 + "****" + cell2;
}

}
